// components/DatePicker.tsx
import { useEffect } from "react";
import moment from "moment";

interface DatePickerProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  readOnly?: boolean;
  error?: {
    hide: boolean;
    message: string;
  };
  minDate?: string;
  maxDate?: string;
  disabled?: boolean;
}

const DatePicker = ({
  label,
  value,
  onChange,
  required = false,
  readOnly = false,
  error,
  minDate,
  maxDate,
  disabled = false
}: DatePickerProps) => {
  const handleDateValidation = (date: string) => {
    if (minDate && date < minDate) {
      return moment(minDate).format("YYYY-MM-DD");
    }
    if (maxDate && date > maxDate) {
      return moment(maxDate).format("YYYY-MM-DD");
    }
    return date;
  };

  return (
    <div style={{ marginTop: "10px", display: "flex", alignItems: "center", gap: "1rem" }}>
      <label style={{ fontWeight: "600", maxWidth: "252px" }}>
        {label}
        {required && <span style={{ color: "red", fontSize: ".8rem" }}>*</span>}
      </label>
      <div style={{ display: "flex", flexDirection: "column" }}>
        <input
          type="date"
          value={value}
          onChange={(e) => onChange(handleDateValidation(e.target.value))}
          style={{
            padding: "4px 6px",
            border: `1px solid ${error?.hide ? "#e74c3c" : "#ccc"}`,
            borderRadius: "4px",
            marginTop: "4px",
            backgroundColor: readOnly || disabled ? "#ddd" : "white"
          }}
          readOnly={readOnly}
          disabled={disabled}
          min={minDate}
          max={maxDate}
        />
        {error?.hide && (
          <div style={{
            padding: "2px 0",
            color: "#e74c3c",
            fontSize: "0.875rem"
          }}>
            {error.message}
          </div>
        )}
      </div>
    </div>
  );
};

export default DatePicker;